module.exports = __webpack_public_path__ + "static/media/www.sectormicro.com.a212ae4e.png";